export default "__VITE_ASSET__CvMVrCDK__"